import { LoadingBackground } from '../../../../Core/default';
import classNames from 'classnames';
import React, { useEffect, useState } from 'react';
import { useActivate } from 'react-activation';
import './index.less';

const GameImageLoad = ({ src }) => {
  const [loadComplete, setLoadComplete] = useState(false);
  const [displaySrc, setDisplaySrc] = useState(src || LoadingBackground);
  const [again, setAgain] = useState(false);

  useActivate(() => {
    setAgain(true);
  });

  useEffect(() => {
    setLoadComplete(false);
    setDisplaySrc(src || LoadingBackground);
  }, [src]);

  return (
    <div className={classNames('game-image', loadComplete && 'game-image-loaded')}>
      <div className={again && loadComplete ? 'game-image-placeholder-hidden' : loadComplete ? 'game-img-loading-transition' : 'game-image-placeholder'}>
        <img src={LoadingBackground} alt="" />
      </div>
      <img
        className={again && loadComplete ? 'game-image-img-end' : loadComplete ? 'game-image-img game-img-transition' : 'game-image-img'}
        tabIndex={0}
        src={displaySrc}
        alt=""
        onLoad={() => {
          setLoadComplete(true);
        }}
        onError={() => {
          setDisplaySrc(LoadingBackground);
          setLoadComplete(true);
        }}
      />
    </div>
  );
};

export default GameImageLoad;
